import React from "react"
import { TransactionEventFilterEnum } from "./TransactionEnum"
import { Transaction } from "@Safemate/Model/Transaction"
import { formatDate } from "@Safemate/utils"
import { sanitizeAddress } from "@Safemate/utils"
import {Routine} from "redux-saga-routines";
import {Action, ActionFunctionAny} from "redux-actions";
import { TransactionSource } from "@Safemate/map/TransactionSourceEnum"
import SignalBars from "@Safemate/DeviceList/DeviceList/signalBars"
import GoogleUtils from "@Safemate/googleUtils"
import Loader from "@Elements/Loader"
import { Tr } from "./Log"
import { AppState } from "@Safemate/Store/types"
import { connect } from "react-redux"
import { useIntl } from "react-intl"
import { AlarmAnalysisState, NotificationEventsState } from "@Safemate/map/Store/types"
import { FirstTd, LastTd, Td, Th } from "@Safemate/map/Log/table"
import { Timeline } from "@Safemate/Timeline"
import { alarmAnalysis, evaluatePosition, getNotificationEvents } from "./Store/routines"
import { DeviceHardwareEnum, isGx8, isStationary } from "@Safemate/DeviceHardwareEnum";
import { getExportColumnWidth } from "@Safemate/UserAdmin/Users/utils";
import { supportGsmStrength } from "@Safemate/Settings/tabDefinition";
import { convertScale } from "@Safemate/DeviceList/DeviceList/TableElements";
import { Button } from "react-bootstrap";

export const RowsPerPage = 20;

export const transactionTimeFilterValues = [
    {value: 1, label: "previousHour"},
    {value: 24, label: "previousDay"},
    {value: 72, label: "previousThreeDays"},
    {value: 168, label: "previousWeek"},
    {value: 336, label: "previousTwoWeeks"}
]

export const transactionEventFilterValues = [
    { value: TransactionEventFilterEnum.ALARM, label: "alarmFilter"},
    { value: TransactionEventFilterEnum.GEOFENCE, label: "geofenceFilter"},
    { value: TransactionEventFilterEnum.BATTERY, label: "batteryFilter"},
    { value: TransactionEventFilterEnum.FAILED_SELFCHECK, label: "failedSelfcheckFilter"},
    { value: TransactionEventFilterEnum.DEVICE_STATE, label: "deviceStateFilter"},
    { value: TransactionEventFilterEnum.POSITION, label: "positionFilter"},
    { value: TransactionEventFilterEnum.TECHNICAL, label: "technicalFilter"},
    { value: TransactionEventFilterEnum.PASSING, label: "passingFilter"},
    { value: TransactionEventFilterEnum.PERIODIC, label: "periodicFilter"}
]

export const mapHeader = (formatMessage: any, dehaId: number, detailed: boolean, showPosition: boolean) => {
  return <tr>
    <th style={{width: "150px"}}>{formatMessage({id: "date", defaultMessage: "Dato"}).toUpperCase()}</th>
    <th>{formatMessage({id: "msgType", defaultMessage: "MELDING"}).toUpperCase()}</th>
    {!isStationary(dehaId) && showPosition && <th>{formatMessage({id: "position", defaultMessage: "POSISJON"}).toUpperCase()}</th>}
    {detailed && <th style={{width: "100px"}}>{formatMessage({id: "comm", defaultMessage: "KOMM."}).toUpperCase()}</th>}
    <th style={{width: "100px"}}>{formatMessage({id: "battery", defaultMessage: "BATTERI"}).toUpperCase()}</th>
    {isStationary(dehaId) && detailed && <th>{formatMessage({id: "sensor", defaultMessage: "SENSOR"}).toUpperCase()}</th>}
    {!isStationary(dehaId) && <th style={{width: "100px"}}>{formatMessage({id: "gsm", defaultMessage: "GSM"}).toUpperCase()}</th>}
    {!isStationary(dehaId) && detailed && <th style={{width: "100px"}}>{formatMessage({id: "sat", defaultMessage: "SAT"}).toUpperCase()}</th>}
    {detailed && <th style={{width: "130px"}}>{formatMessage({id: "transactionId", defaultMessage: "Transaksjons-id"}).toUpperCase()}</th>}
  </tr>
}

export const mapHeaderForExport = (formatMessage: any, dehaId: number, detailed: boolean, showPosition: boolean) => {
  const header = [];
  header.push(formatMessage({id: "date", defaultMessage: "Dato"}).toUpperCase());
  header.push(formatMessage({id: "msgType", defaultMessage: "MELDING"}).toUpperCase());
  !isStationary(dehaId) && showPosition && header.push(formatMessage({id: "position", defaultMessage: "POSISJON"}).toUpperCase());
  detailed && header.push(formatMessage({id: "comm", defaultMessage: "KOMM."}).toUpperCase());
  header.push(formatMessage({id: "battery", defaultMessage: "BATTERI"}).toUpperCase());
  isStationary(dehaId) && detailed && header.push(formatMessage({id: "sensor", defaultMessage: "SENSOR"}).toUpperCase())
  !isStationary(dehaId) && header.push(formatMessage({id: "gsm", defaultMessage: "GSM"}).toUpperCase())
  !isStationary(dehaId) && detailed && header.push(formatMessage({id: "sat", defaultMessage: "SAT"}).toUpperCase())
  detailed && header.push(formatMessage({id: "transactionId", defaultMessage: "Transaksjons-id"}).toUpperCase());
  return header;
}

export const mapDataForExport = (formatMessage: any, dehaId: number, transactions: Transaction[], detailed: boolean, showPosition: boolean) => {
  const exportData = [];
  exportData.push(mapHeaderForExport(formatMessage, dehaId, detailed, showPosition));
  const styleData = [];
  const gsmStrength = supportGsmStrength.get(dehaId) || supportGsmStrength.get(DeviceHardwareEnum.ALL);
  for(let i = 0; i < transactions.length; i++){
    const tx = transactions[i];
    const data = [];

    let scaledSignal = 0;

    if(gsmStrength){
      const offset = gsmStrength.low === 0 ? 0 : -(gsmStrength.low);
      const scale =  100 / (gsmStrength.high + offset);
      const strength = (tx.gsmStrength + offset) * scale;
      scaledSignal = convertScale(strength);
    }

    data.push(formatDate(tx.txDate, true, false, true, false, false, formatMessage));
    data.push(formatMessage({id: `metyDesc${tx.metyId}`, defaultMessage: `metyDesc${tx.metyId}`}));
    !isStationary(dehaId) && showPosition && data.push(tx.address ? tx.address.replace(/<br>/gi, "\n").trim() : "");
    detailed && data.push(TransactionSource[tx.txSource]);
    data.push(tx.battery > 0 ? `${tx.battery}%` : "");
    isStationary(dehaId) && detailed && data.push(tx.sensorName || "");
    !isStationary(dehaId) && data.push(tx.gsmStrength > 0 ? `${scaledSignal}/5` : "");
    !isStationary(dehaId) && detailed && data.push(tx.numSatellites || "");
    detailed && data.push(`${tx.id}`);
    exportData.push(data);
    styleData.push(data.map(d => d.length));
  }
  const exportStyle = getExportColumnWidth(styleData);
  return {exportData, exportStyle};
}

interface TransactionProps{
  transactions: Transaction[];
  dehaId: number;
  detailed: boolean;
  showPosition: boolean;
  notificationEvent: NotificationEventsState;
  alarmAnalysis: AlarmAnalysisState;
  getAlarmAnalysis: Routine<ActionFunctionAny<Action<any>>>;
  evaluatePosition: Routine<ActionFunctionAny<Action<any>>>;
  getNotificationEvents: Routine<ActionFunctionAny<Action<any>>>;
}

const mapStateToTransactionsProps = ({txLog: { alarmAnalysis, notificationEvent, device: { device: { dehaId }}}}:AppState) => {
  return {
    dehaId,
    notificationEvent,
    alarmAnalysis
  }
}

const mapDispatchToProps = {
  getNotificationEvents,
  evaluatePosition,
  getAlarmAnalysis: alarmAnalysis
}

export const TranscationTable = connect(mapStateToTransactionsProps, mapDispatchToProps)(({transactions, dehaId, detailed, showPosition, evaluatePosition, getAlarmAnalysis, getNotificationEvents, notificationEvent, alarmAnalysis}: TransactionProps) => {

  const { formatMessage } = useIntl();
  const [ selectedRow, setSelectedRow ] = React.useState(0);
  const [ addressLookupStarted, setAddressLookupStarted ] = React.useState([]);

  const loadDetails = (transaction: Transaction) => {
    getNotificationEvents(transaction.id);
    if(transaction.alarmType)
    getAlarmAnalysis(transaction.id);
    setSelectedRow(selectedRow === transaction.id ? 0 : transaction.id);
  }

  const startAddressLookup = (transaction: Transaction) => {
    evaluatePosition(transaction.id);
    addressLookupStarted.push(transaction.id);
    setAddressLookupStarted([...addressLookupStarted]);
  }

  return(
    transactions.map(tx => {
        return(
          <>
          <Tr onClick={() => {
            if(tx.alarmType || tx.notifyEvent){
              loadDetails(tx);
            }
          }} alarm={tx.alarmType} notifyEvent={tx.notifyEvent} new={tx.new}>
            <td>{formatDate(tx.txDate, true, false, true, false, false, formatMessage)}</td>
            <td>{formatMessage({id: `metyDesc${tx.metyId}`, defaultMessage: `metyDesc${tx.metyId}`})}</td>
            {!isStationary(dehaId) && showPosition && <td>{(tx.posType === 7 || (!tx.posLati && !tx.posLong))
                  ? ""
                  : addressLookupStarted.includes(tx.id)
                    ? tx.addressLookupDone 
                      ? tx.poorPosition && !tx.poorPositionDisplayed 
                        ? "poorPosition" 
                        : <span dangerouslySetInnerHTML={{__html: sanitizeAddress(tx.address 
                          ? tx.address 
                          : tx.posLati && tx.posLong && + tx.posLati + "<br>" + tx.posLong)}} /> 
                      : tx.posLati 
                        ? <Loader/> 
                        : ''
                    : <Button onClick={() => startAddressLookup(tx)}>{formatMessage({id: "getAddress", defaultMessage: "Hent addresse"})}</Button>}
            </td>}
            {detailed && <td>{TransactionSource[tx.txSource]}</td>}
            <td>{tx.battery > 0 ? `${tx.battery}%` : ""}</td>
            {isStationary(dehaId) && detailed && <td>{tx.sensorName}</td>}
            {!isStationary(dehaId) && <td>{tx.gsmStrength > 0 ? <SignalBars dehaId={dehaId} size={30} strength={tx.gsmStrength} /> : ""}</td>}
            {!isStationary(dehaId) && detailed && <td>{tx.numSatellites || ""}</td>}
            {detailed && <td>{tx.id}</td>}
          </Tr>
          {notificationEvent[tx.id] && notificationEvent[tx.id].length > 0 && selectedRow === tx.id &&
            <tr key={`notification-${tx.id}`}>
              <td colSpan={10}>
                <table style={{width: "100%", marginBottom: "1em"}}>
                  <thead>
                    <tr>
                      <Th>{formatMessage({id: "time", defaultMessage:"Tidspunkt"})}</Th>
                      <Th>{formatMessage({id: "events", defaultMessage:"Events"})}</Th>
                      <Th>{formatMessage({id: "receiver", defaultMessage:"Mottaker"})} / {formatMessage({id: "descriptionText", defaultMessage:"Beskrivelse"})}</Th>
                    </tr>
                  </thead>
                  <tbody>
                  {notificationEvent[tx.id].map(event =>
                    <tr key={event.evtyId}>
                      <FirstTd>
                        <span xs={8}>{formatDate(event.createdTime, true, false, true, false, false, formatMessage)}</span>
                        </FirstTd>
                      <Td>
                        <span>{formatMessage({id: `et.${event.eventType.name}`, defaultMessage: event.eventType.name})}</span>
                      </Td>
                      <LastTd>
                        <span>{event.description}</span>
                      </LastTd>
                    </tr>
                  )}
                  </tbody>
                </table>
              </td>
            </tr>}
            {alarmAnalysis[tx.id] && selectedRow === tx.id &&
              <tr>
                <td colSpan={99}>
                  <Timeline 
                    id={tx.id}
                    alarmAnalysis={alarmAnalysis}
                    renderCallback={() => {}}
                    canvasProperties={{
                      margin: 5,
                      notes: true,
                      textSize: 13
                    }}
                  />
                </td>
              </tr>}
          </>
        )
    })
  )
})


export const getLocations = async (txs: Transaction[], render: boolean, maps?: any) => {
  for(let i = 0; i < txs.length; i++){
    await getLocation(txs[i],render, maps);
  }
}

export const getLocation = async (tx: Transaction, render: boolean, maps?: any) => {

  if(tx.posType == 0){
    await getLocationAll(tx, render, maps);
  }else if( tx.poorPosition && tx.poorPositionDisplayed ){
    await getLocationAll(tx, render, maps);
  }
  else{
    tx.address = "";
    tx.addressLookupDone = true;
    if( !tx.numSatellites ){
      tx.numSatellites = 0;
    }
  }
}

export const getLocationAll = async (tx: Transaction, render: boolean, maps?: any) => {
  if(tx.posType === 7){
    tx.address = "";
    tx.addressLookupDone = true;
    return;
  }
  if(!tx.address){
    tx.address = tx.posLati ? `${tx.posLati}<br>${tx.posLong}` : "";
    tx.addressLookupDone = false;
  }
  if(!tx.addressLookupDone && tx.posLati && tx.posLong){
    try{
      const address = await GoogleUtils.addressLookup(parseFloat(tx.posLati), parseFloat(tx.posLong), tx.dekmId, tx.inloId, maps);
      if(address){
        tx.address = address.replace(/,/g, '<br>');
      } else{
        tx.address = tx.posLati ? `${tx.posLati}<br>${tx.posLong}` : "";
      }
      tx.addressLookupDone = true;
      render = !render;
      // tx.posTimeDiff = (tx.sysTimeUTC - tx.posTime > 60000) ? tx.posTime
    }
    catch(e){
      tx.address = tx.posLati ? `${tx.posLati}<br>${tx.posLong}` : "";
      tx.addressLookupDone = true;
      render = !render;
    }
    
  }
} 